export default {
	objDados:null,
}